import { makeStyles, webLightTheme } from "@fluentui/react-components";

export const useReportsPageStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
});

